document.addEventListener('DOMContentLoaded', function () {
  if (document.querySelector('.personalizer-help-text') === null) {
    return;
  }

  if (document.querySelector('.pplr-c-button') !== null) {
    document.querySelector('.personalizer-help-text').classList.remove('visually-hidden');
  }

  // Select the nodes that will be observed for mutations
  const targetNodes = document.querySelectorAll(".shopify-app-block");
  
  // Options for the observer (which mutations to observe)
  const mutationConfig = { attributes: false, childList: true, subtree: true };
  
  // Callback function to execute when mutations are observed
  const mutationCallback = (mutationList, observer) => {
    for (const mutation of mutationList) {
      if (mutation.type !== "childList") {
        return;
      }
      if (mutation.target.classList.contains("product-personalizer") && mutation.target.querySelector('.pplr-c-button') !== null) {
        document.querySelector('.personalizer-help-text').classList.remove('visually-hidden');
      }
    }
  };
  
  // Create an observer instance linked to the callback function
  const observer = new MutationObserver(mutationCallback);
  
  // Start observing the target nodes for configured mutations
  targetNodes.forEach((targetNode) => {
    observer.observe(targetNode, mutationConfig);
  });


});